// extracted by mini-css-extract-plugin
module.exports = {"course":"App_course__19pP2","course-details":"App_course-details__227C9","course-code":"App_course-code__1wNjt","course-title":"App_course-title__oXjFr"};